<template>
  <div class="pt-4">
    <v-row no-gutters justify="center" align="center" class="pt-8">
      <v-icon large color="accent">whatshot</v-icon>
    </v-row>
    <v-row no-gutters justify="center" align="center" class="pt-2 font-weight-medium">
      Bientôt, publiez un formulaire permettant de recevoir de nouvelles demandes directement ici
    </v-row>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
</style>
